import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';
import api from './api';
import brand from './brand';
import baseComponent from './base-component';
import codeTemplate from "./code-template";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    brand,
    baseComponent,
    api,
    codeTemplate
  },
  strict: process.env.DEV,
});
